import gql from 'graphql-tag';

export const SINGLE_CROP_QUERY = gql`
  query SingleCrop($id: ID!) {
    crop(id: $id) {
      id
      crop_name
      total_grow_time
      max_hold_time
      harvest_buffer_time
      sowing_density
      sow_density_unit
      yield_per_tray
      yield_unit
      notes
      status
      buffer_percentage
      created_at
      updated_at
      edge_sizes {
        edges {
          node {
            id
            size
            unit
            price_per_item
          }
        }
      }
      steps {
        edges {
          node {
            id
            name
            time_to_start_after_first_step
            description
          }
        }
      }
    }
  }
`;
